<template>
  <PageLayout
    class="work-home"
    :class="homeThemeClass"
    :leftArrow="false"
    langChooseLocation="left"
    navBarSlot="right"
    :clickLeft="() => {}"
    :showNavBar="false"
  >
    <!-- <template #right>
      <p
        class="work-home-history-btn"
        @click="goToPage('list', 'clickHomeTopGoOrderList')"
      >
        <van-badge :dot="hasRedDot">
          <van-icon
            name="underway-o"
            size="15"
            class="work-home-history-btn-ico"
          />{{ languages.mylist_headerTitle }}
        </van-badge>
      </p>
    </template>
    <div class="work-home-wrap">
      <faq-notice-bar :source="locationType.homePage"></faq-notice-bar>
      <template v-if="faqSiteName && hasFaqClassList">
        <section-title :title="languages.smartOrderNeedHelp"></section-title>
        <van-form class="work-home-search">
          <van-search
            class="search"
            :placeholder="languages.smartOrderInputQuestion"
            background="transparent"
            @click="goToPage('workSearch', 'clickHomeGoSearch')"
          >
            <template #left-icon>
              <div></div>
            </template>
            <template #right-icon>
              <van-icon name="search" class="search-ico" />
            </template>
          </van-search>
        </van-form>
      </template>
      <section-title
        :title="languages.smartOrderCreate"
        v-show="hasWorkTempList && !isJumpAiBot"
      ></section-title>
      <work-temp-list
        v-show="hasWorkTempList && !isJumpAiBot"
        :source="locationType.homePage"
      ></work-temp-list>
      <template v-if="hasFaqClassList || (isLogin && isJumpAiBot)">
        <section-title :title="languages.smartOrderLookHelpTip"></section-title>
        <div class="work-home-faq">
          <div
            class="work-home-faq-item"
            v-for="item in faqClassList"
            :key="item.id"
            @click="goToFaqList(item.id)"
          >
            <img
              :src="item.icon"
              class="work-home-faq-item-ico"
              v-if="item.icon"
            />
            <em class="icon iconfont icon-box" v-else></em>
            <div class="work-home-faq-item-text">
              <p class="van-ellipsis">{{ item.text }}</p>
              <van-icon name="arrow" size="16" class="icon" />
            </div>
          </div>
          <div
            class="work-home-faq-item"
            @click="contactService"
            v-if="isLogin && isJumpAiBot"
          >
            <em class="icon iconfont icon-service"></em>
            <div class="work-home-faq-item-text">
              <p class="van-ellipsis">
                {{ languages.smartOrderContactService }}
              </p>
              <van-icon name="arrow" size="16" class="icon" />
            </div>
            <span class="beta">BETA</span>
          </div>
        </div>
      </template>
    </div> -->
    <div class="work-home-content-box">
      <div class="work-home-top">
        <div class="work-home-title-block">
          <div class="work-home-title-content">
            <span v-if="gameName" class="work-home-game-name">
              {{ gameName ? '&lt;' + gameName + '&gt;' : '' }}
            </span>
            <span class="work-home-title">
              {{ languages.workHomeTitle }}
            </span>
          </div>
        </div>
        <div class="lang-choose">
          <Select
            class="lang-choose-select"
            v-model="langChooseValue"
            @change="changeLang"
          >
            <option
              v-for="(text, langVal) in realLangList"
              :key="langVal"
              :value="langVal"
            >
              {{ text }}
            </option>
          </Select>
        </div>
      </div>
      <div
        class="work-home-banner work-home-banner-swiper-container swiper-container"
        v-if="workHomeBannerList.length > 0"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in workHomeBannerList"
            :key="index"
          >
            <img :src="item.img" class="slide-img" alt="banner-img" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="work-home-bottom">
        <div class="work-home-content-left">
          <template v-if="faqSiteName && hasFaqClassList">
            <van-form class="work-home-search">
              <van-search
                class="search"
                :placeholder="languages.workHomeSearchPlaceholder"
                @click="goToPage('workSearch', 'clickHomeGoSearch')"
              >
                <template #left-icon>
                  <div></div>
                </template>
                <template #right-icon>
                  <van-icon name="search" class="search-ico" />
                </template>
              </van-search>
            </van-form>
          </template>
          <template v-if="hasFaqClassList">
            <div class="work-home-faq">
              <div
                class="work-home-faq-item"
                v-for="item in faqClassList"
                :key="item.id"
                :class="{
                  'work-home-faq-item-unfold': isHomeFaqExpanded(item.id)
                }"
              >
                <div
                  class="work-home-faq-item-text"
                  @click="toggleHomeFaq(item)"
                >
                  <p class="van-ellipsis">{{ item.text }}</p>
                  <span class="work-home-faq-arrow"></span>
                </div>
                <div
                  class="work-home-faq-detail"
                  v-if="isHomeFaqExpanded(item.id)"
                >
                  <template v-if="item.sub && item.sub.length">
                    <div
                      class="work-home-faq-group"
                      v-for="sub in item.sub"
                      :key="sub.id"
                    >
                      <p class="work-home-faq-group-title">
                        {{ sub.text }}
                      </p>
                      <template
                        v-if="
                          homeFaqArticleList[sub.id] &&
                          homeFaqArticleList[sub.id].length > 0
                        "
                      >
                        <p
                          class="work-home-faq-article"
                          v-for="article in homeFaqArticleList[sub.id]"
                          :key="article.ID"
                          @click="goToHomeFaqDetail(article.ID)"
                        >
                          <span class="van-ellipsis">{{ article.TITLE }}</span>
                          <van-icon name="arrow" size="16" class="icon" />
                        </p>
                      </template>
                      <p v-else class="work-home-faq-empty">
                        {{
                          homeFaqLoadingMap[item.id]
                            ? 'Loading'
                            : languages.smartOrderComing
                        }}
                      </p>
                    </div>
                  </template>
                  <p v-else class="work-home-faq-empty">
                    {{ languages.smartOrderComing }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="work-home-content-right">
          <template v-if="faqSiteName && hasFaqClassList">
            <van-form class="work-home-search">
              <van-search
                class="search"
                :placeholder="languages.workHomeSearchPlaceholder"
                @click="goToPage('workSearch', 'clickHomeGoSearch')"
              >
                <template #left-icon>
                  <div></div>
                </template>
                <template #right-icon>
                  <van-icon name="search" class="search-ico" />
                </template>
              </van-search>
            </van-form>
          </template>
          <div class="user-info-box">
            <div class="user-info-top">
              <div class="user-avatar"></div>
              <div class="user-info">
                <p class="user-name">{{ loginAccount }}</p>
                <p class="user-uid">UID: {{ uid }}</p>
              </div>
              <div
                class="work-home-history-btn"
                @click="goToPage('list', 'clickHomeTopGoOrderList')"
              >
                <van-badge :dot="hasRedDot">
                  {{ languages.mylist_headerTitle }}
                </van-badge>
              </div>
            </div>
            <div v-if="userInfo.serverName" class="user-sever-box">
              <div class="user-sever-label">
                {{ languages.workHomeCurServer }}
              </div>
              <div class="user-sever-name">
                {{ userInfo.serverName || '' }}
              </div>
            </div>
          </div>
          <!-- <div class="self-service-box">
            <div class="self-service-title">{{ languages.workHomeSelfService }}</div>
            <div class="self-service-btn-list">
              <div v-for="item in faqClassList" :key="item.id" class="self-service-btn-item" @click="goToFaqList(item.id)">
                <span class="self-service-btn-text">{{ item.text }}</span>
              </div>
              <div v-show="hasWorkTempList && !isJumpAiBot" v-for="item in workTempList" :key="item.key" class="self-service-btn-item" @click="goTemp(item)">
                <span class="self-service-btn-text">{{ item.name }}</span>
              </div>
            </div>
          </div> -->
          <div class="service-entrance-box" @click="contactService">
            <div v-if="isJumpAiBot" class="ai-service-entrance big">
              <div class="ai-service-entrance-icon"></div>
              <div class="ai-service-entrance-title">
                {{ languages.workHomeAiService }}
              </div>
              <div class="ai-service-entrance-btn">
                {{ languages.workHomeServiceEntrance }}
              </div>
            </div>
            <div v-else class="artificial-service-entrance big">
              <div class="artificial-service-entrance-icon"></div>
              <div class="artificial-service-entrance-title">
                {{ languages.workHomeArtificialService }}
              </div>
              <div class="artificial-service-entrance-btn">
                {{ languages.workHomeServiceEntrance }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ContactServerBtn
      class="service-btn"
      :customClick="contactService"
      v-if="isLogin && isJumpAiBot"
    ></ContactServerBtn> -->
    <NoticePopup
      v-bind:visible.sync="isNoticePopup"
      :languages="languages"
      :noticeList="noticeList"
      @closePopup="isNoticePopup = false"
    ></NoticePopup>
    <AiBotPopup
      v-bind:visible.sync="showAiBotPopup"
      :aiBotLink="aiBotLink"
    ></AiBotPopup>
  </PageLayout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Swiper from 'swiper';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import SectionTitle from '@components/officialSupport/common/SectionTitle.vue';
import Select from '@components/officialSupport/common/Select.vue';
import WorkTempList from '@components/officialSupport/WorkTempList.vue';
import NoticePopup from '@components/officialSupport/NoticePopup.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import AiBotPopup from '@components/officialSupport/AiBotPopup.vue';
import globalConfig from '@utiles/globalConfig';
import {
  clickButton,
  locationType,
  showPopup
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import ContactServerBtn from '@components/officialSupport/ContactServerBtn.vue';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import aiBot from '@mixins/officialSupport/aiBot';
import { SET_LANG, SET_IS_SPECIAL_DIFY_USER } from '@store/officialSupport';
import { getSupportThemeClass } from '@utiles/officialSupport/theme';
let from = globalConfig.getHrefParam('from');
const isAi = globalConfig.getHrefParam('ai') == '1';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'WorkHome',
  mixins: [pointStayTime, iframeMessage, aiBot],
  data() {
    return {
      openNoticePopup: false, // 是否开启客服公告弹框
      hasShowedNoticePopup: false, // 是否弹过，弹过一次之后不再弹，刷新页面重新请求接口
      isNoticePopup: false,
      noticeList: [],
      isExeUserCenter: ['pnsClient', 'exeClient'].includes(from), // 是否是微端打开
      isExe: globalConfig.getHrefParam('device') == 'exe',
      gameId:
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        '',
      locationType,
      hasRedDot: false,
      // showAiBtn: isAi,
      showAiBotPopup: false,
      langChooseValue: '',
      homeFaqActiveIds: [],
      homeFaqArticleList: {},
      homeFaqLoadingMap: {},
      homeFaqToggleLockMap: {}
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mylist,
      curLang: state => state.curLang,
      langList: state => state.langList,
      supportLang: state => state.supportLang,
      faqSiteName: state => state.faqSiteName,
      faqClassList: state => state.faqClassList,
      workTempList: state => state.workTempList,
      uid: state => state.uid,
      loginAccount: state => state.loginAccount,
      gameName: state => state.gameName,
      userInfo: state => state.userInfo,
      isLogin: state => state.isLogin
    }),
    ...mapGetters(['hasFaqClassList', 'hasWorkTempList']),
    // 主题挂在组件自身，路由离开时不依赖父级 class，避免过渡闪帧
    homeThemeClass() {
      return getSupportThemeClass(this.gameId);
    },
    realLangList() {
      return Object.keys(this.supportLang).length > 0
        ? this.supportLang
        : this.langList;
    },
    workHomeBannerList() {
      if (this.gameId == 456 || this.gameId == 386) {
        return [
          {
            img: require('@assets/image/officialSupport/roworld/banner.webp'),
            link: ''
          },
        ];
      }
      return [];
    },
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        if (newRoute?.name == 'workhome') {
          this.checkHasNewReply();
        }
      },
      deep: true
    },
    curLang(val, oldVal) {
      this.langChooseValue = val;
      if (val != oldVal) {
        this.homeFaqActiveIds = [];
        this.homeFaqArticleList = {};
        this.homeFaqLoadingMap = {};
        this.homeFaqToggleLockMap = {};
        this.getFaqClassList(true);
        this.getWorkTempList(true);
        this.getFaqNotice();
        // 自动展开前两个faq
        this.faqClassList.slice(0, 2).forEach(item => this.toggleHomeFaq(item));
      }
    }
  },
  async created() {
    this.getNoticePopup().then(() => {
      this.checkShowNoticePopup();
    });
    this.checkHasNewReply();
  },
  mounted() {
    this.$nextTick(() => {
      this.langChooseValue = this.curLang;
      this.initSwiper();
      // 自动展开前两个faq
      this.faqClassList.slice(0, 2).forEach(item => this.toggleHomeFaq(item));
    });
  },
  methods: {
    ...mapActions([
      'getFaqClassArticleList',
      'getFaqClassList',
      'getWorkTempList',
      'getFaqNotice',
      'getNoticePopupConfig',
      'postShowNoticeRecord',
      'getWorkList'
    ]),
    changeLang(value) {
      this.$store.commit(SET_LANG, value);
      clickButton({
        btnName: 'clickChooseLang',
        otherParams: {
          lang: value
        }
      });
    },
    goTemp(item) {
      const { id, fixedProcessType } = item;
      clickButton({
        btnName: 'clickGoSmartOrder',
        locationKey: locationType.homePage || '',
        otherParams: {
          workTempId: id
        }
      });
      if (+fixedProcessType === 1) {
        this.$router.push({
          name: 'accountdelete',
          query: {
            workTempId: id,
            source: locationType.homePage || ''
          }
        });
        return;
      }
      this.$router.push({
        name: 'worktemp',
        query: {
          workTempId: id,
          source: locationType.homePage || ''
        }
      });
    },
    isHomeFaqExpanded(id) {
      return this.homeFaqActiveIds.includes(id);
    },
    async toggleHomeFaq(item) {
      const now = Date.now();
      const lastToggleAt = this.homeFaqToggleLockMap[item.id] || 0;
      // 300ms 内忽略同项二次切换，避免连点展开/收起互相抵消
      if (now - lastToggleAt < 300) {
        return;
      }
      this.$set(this.homeFaqToggleLockMap, item.id, now);
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.homePage,
        otherParams: {
          faqClassId: item.id
        }
      });
      const activeIndex = this.homeFaqActiveIds.indexOf(item.id);
      if (activeIndex !== -1) {
        this.homeFaqActiveIds.splice(activeIndex, 1);
        return;
      }
      this.homeFaqActiveIds.push(item.id);
      await this.loadHomeFaqArticleList(item);
    },
    async loadHomeFaqArticleList(item) {
      const subList = item.sub || [];
      if (!subList.length || this.homeFaqLoadingMap[item.id]) return;
      this.$set(this.homeFaqLoadingMap, item.id, true);
      try {
        await Promise.all(
          subList.map(async sub => {
            if (this.homeFaqArticleList[sub.id]) return;
            const data = await this.getFaqClassArticleList({
              classId: sub.id
            });
            this.$set(this.homeFaqArticleList, sub.id, data);
          })
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.$set(this.homeFaqLoadingMap, item.id, false);
      }
    },
    goToHomeFaqDetail(faqId) {
      clickButton({
        btnName: 'goFaqDetail',
        locationKey: locationType.homePage,
        otherParams: {
          faqId
        }
      });
      this.$router.push({
        name: 'workfaqdetail',
        query: {
          faqId
        }
      });
    },
    goToFaqList(id) {
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.homePage,
        otherParams: {
          faqClassId: id
        }
      });
      this.$router.push({
        path: '/workfaqlist',
        query: {
          firstClassId: id
        }
      });
    },
    goToPage(name, pointEventName) {
      const pageName = {
        list: 'mylist',
        workSearch: 'worksearch'
      };
      if (pointEventName) {
        clickButton({
          btnName: pointEventName,
          locationKey: locationType.homePage
        });
      }
      pageName[name] && this.$router.push(`/${pageName[name]}`);
    },
    checkShowNoticePopup() {
      if (this.openNoticePopup && !this.hasShowedNoticePopup) {
        this.isNoticePopup = true;
        this.hasShowedNoticePopup = true;
        this.sendShowNoticeRecord();
        showPopup(locationType.noticePopup);
      }
    },
    sendShowNoticeRecord() {
      this.postShowNoticeRecord({
        announcement_id: this.noticeList.map(item => item.id).join(',')
      });
    },
    getNoticePopup() {
      return new Promise(async resolve => {
        const serverId = globalConfig.getHrefParam('serverId');
        let newDevicePlate = globalConfig.getHrefParam('devicePlate');
        const devicePlate = globalConfig.getHrefParam('devicePlate');
        if (['pc', 'h5'].includes(devicePlate)) {
          if (this.isExeUserCenter || this.isExe) {
            newDevicePlate = 'pc';
          } else {
            newDevicePlate = 'h5';
          }
        }
        try {
          const data = await this.getNoticePopupConfig({
            game_id: this.gameId,
            server_id: serverId,
            devicePlate: newDevicePlate,
            zone: this.curLang
          });
          if (data?.has_announce) {
            this.openNoticePopup = true;
            this.noticeList = data?.announcement || [];
            resolve();
          } else {
            resolve();
          }
        } catch (error) {
          resolve();
        }
      });
    },
    async checkHasNewReply() {
      const data = await this.getWorkList({
        is_check_unread: true
      });
      this.hasRedDot = +data?.UNREAD_COUNT > 0 || false;
    },
    contactService() {
      clickButton({
        btnName: 'clickContactService',
        locationKey: locationType.homePage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: this.isJumpAiBot,
          isLogin: this.isLogin
        }
      });
      this.handleContactService('homeBtn');
    },
    initSwiper() {
      try {
        new Swiper('.work-home-banner-swiper-container', {
          loop: true,
          autoplay:
            this.workHomeBannerList.length > 1
              ? {
                  delay: 4000,
                  stopOnLastSlide: false,
                  disableOnInteraction: false
                }
              : false,
          direction: 'horizontal',
          pagination: {
            el: '.swiper-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    }
  },
  components: {
    Select,
    PageLayout,
    SectionTitle,
    WorkTempList,
    NoticePopup,
    FaqNoticeBar,
    ContactServerBtn,
    AiBotPopup
  }
};
</script>

<style lang="scss" scoped>
// .work-home {
//   &-wrap {
//     padding: 0 10px;
//     box-sizing: border-box;
//   }
//   &-history-btn {
//     display: flex;
//     align-items: center;
//     color: var(--text-color);
//     font-size: 14px;
//     &-ico {
//       margin-right: 5px;
//       color: var(--text-color) !important;
//     }
//   }
//   &-search {
//     z-index: 2;
//     background-color: var(--page-bgColor);
//     ::v-deep .van-field__clear {
//       padding: 0 8px 0 16px !important;
//     }
//     .search {
//       overflow: hidden;
//       width: 100%;
//       padding: 0;
//       margin: 0 auto 26px;
//       border-radius: 8px;

//       ::v-deep .van-field__control {
//         color: var(--text-color);
//         caret-color: transparent;

//         &::after {
//           display: none;
//         }
//       }

//       ::v-deep .van-field {
//         line-height: 34px;
//       }
//       ::v-deep .van-icon-search {
//         font-size: 24px;
//         font-weight: bold;
//         color: #767676;
//       }
//       ::v-deep .van-search__content {
//         background-color: var(--block-bg-light-color);
//         border-radius: 8px;
//         padding-left: 10px;
//       }
//     }
//   }
//   &-faq {
//     display: grid;
//     grid-template-columns: repeat(2, minmax(0, 1fr)); /* 防止内容溢出 */
//     grid-auto-rows: auto; /* 多行 */
//     grid-gap: 16px; /* 列中间间隔随意 */
//     justify-content: space-between; /* 列靠边对齐 */
//     width: 100%;
//     margin: 0 auto 16px;
//     &-item {
//       position: relative;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-between;
//       padding: 20px;
//       width: 187px;
//       max-width: 100%; // 最大宽度为网格宽度，防止内容溢出
//       height: 120px;
//       border-radius: 20px;
//       box-sizing: border-box;
//       background-color: var(--block-bg-light-color);
//       cursor: pointer;
//       &-ico {
//         color: var(--main-color);
//         width: 40px;
//       }
//       &-text {
//         display: flex;
//         justify-content: space-between;
//         font-size: 16px;
//         font-weight: 500;
//         .icon {
//           display: block;
//           font-size: 16px;
//           color: var(--back-color);
//         }
//       }
//     }
//     .beta {
//       position: absolute;
//       top: 20px;
//       right: 20px;
//       color: var(--main-color);
//       line-height: 18px;
//       font-weight: 500;
//       font-size: 10px;
//       padding-left: 4px;
//       padding-right: 4px;
//       border-radius: 5px;
//       border: 1px solid var(--main-color);
//     }
//   }
//   .icon {
//     font-size: 40px;
//     color: var(--main-color);
//   }
//   .service-btn {
//     display: block;
//     position: relative;
//     bottom: unset;
//     right: unset;
//   }
// }
// // 横屏兼容
// @media screen and (orientation: landscape) {
//   .work-home-faq {
//     display: flex;
//     flex-wrap: wrap;
//     justify-content: flex-start;
//     &-item {
//       width: 200px;
//     }
//   }
// }
</style>
<style lang="scss">
.work-home {
  .swiper-pagination-bullet {
    width: 1.3889vh; // 15 / 1080 * 100 = 1.3889vh
    height: 1.3889vh; // 15 / 1080 * 100 = 1.3889vh
    background: url('~@assets/image/officialSupport/bullet.png') no-repeat center/contain;
    opacity: 1;
    margin: 0 0.463vh; // 5 / 1080 * 100 = 0.4630vh
  }
  .swiper-pagination-bullet-active {
    background: url('~@assets/image/officialSupport/bullet-active.png') no-repeat center/contain;
  }
}
</style>
